import { render, staticRenderFns } from "./general-ledger-enquiry.vue?vue&type=template&id=a49c62ce&"
import script from "./general-ledger-enquiry.vue?vue&type=script&lang=js&"
export * from "./general-ledger-enquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports